import PGlobal from '../PGlobal';
let _instance;
export default class AudioDataMgr extends PIXI.utils.EventEmitter {
    /**
     * @returns {AudioDataMgr}
     */
    static get instance(){
        if(!_instance){
            _instance = new AudioDataMgr;
        }
        return _instance;
    }

    constructor(){
        super();
        this.audioDatas = {};
        this.waiters = {};
        PGlobal.m.listen(6, 51, proto.com.proto.scene.MAudioData, (data)=>{
            this._onAudioData(data);
        });
    }

    getData(id, callback, ctx){
        console.log("获取波形数据....", id);
        if(this.audioDatas[id]){
            return callback.call(ctx, this.audioDatas[id]);
        }
        let list = this.waiters[id];
        if(!list){
            this.waiters[id] = list = [];
        }
        list.push({callback: callback, ctx: ctx});

        PGlobal.m.send(SCENE, 6, 50, new proto.com.proto.s.MString([id]));
    }

    _onAudioData(data){
        data = data.data;
        const id = data.id;
        data = data.data;
        data = "data:audio/mp3;base64," + data;
        this.audioDatas[id] = data;
        const list = this.waiters[id];
        console.log("_onAudioData.....", id);
        if(list){
            list.forEach(v=>{
                v.callback.call(v.ctx, data);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/AudioDataMgr.js